import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import { SeoProvider } from "./context/SeoContext";
import { Toaster } from "sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import CartSheet from "./components/CartSheet";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import Auth from "./pages/Auth";
import VerifyEmail from "./pages/VerifyEmail";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import MyAddresses from "./pages/MyAddresses";
import Contact from "./pages/Contact";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import PaypalReturn from "./pages/PaypalReturn";
import { WealthGuide, KitchenCorner } from "./pages/Sections";
import ArticleDetail from "./pages/ArticleDetail";
import AdminDashboard from "./pages/AdminDashboard";
import AssistantDashboard from "./pages/AssistantDashboard";

function ProtectedRoute({ children, role }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) return <div className="p-12 text-center text-[#4B634B]">Chargement...</div>;
  if (!user) return <Navigate to="/auth" state={{ from: loc }} replace />;
  if (role && user.role !== role) return <Navigate to="/" replace />;
  return children;
}

function Shell() {
  return (
    <div className="App min-h-screen flex flex-col">
      <Header />
      <CartSheet />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/shop/:id" element={<ProductDetail />} />
          <Route path="/auth" element={<Auth />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/mes-adresses" element={<ProtectedRoute><MyAddresses /></ProtectedRoute>} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/checkout/success" element={<CheckoutSuccess />} />
          <Route path="/checkout/paypal-return" element={<PaypalReturn />} />
          <Route path="/wealth-guide" element={<Navigate to="/healthy-guides" replace />} />
          <Route path="/healthy-guides" element={<WealthGuide />} />
          <Route path="/kitchen-corner" element={<KitchenCorner />} />
          <Route path="/article/:id" element={<ArticleDetail />} />
          <Route path="/admin" element={<ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute>} />
          <Route path="/assistant" element={<ProtectedRoute><AssistantDashboard /></ProtectedRoute>} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <AuthProvider>
          <SeoProvider>
            <CartProvider>
              <Shell />
              <Toaster position="top-right" richColors />
            </CartProvider>
          </SeoProvider>
        </AuthProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}
